/**
 * Body-grade disclaimer (CONTRACT 도메인 불변식 #5).
 * Must appear on every issue / gate-pass surface.
 */
export function Disclaimer(): JSX.Element {
  return (
    <div className="disclaimer" role="note">
      <strong>안내:</strong> 본 도구는 <strong>사전 정의된 룰만 검사</strong>합니다.
      미정의 리스크 및 <strong>최종 통관 가부는 통관사 확인 사항</strong>이며, 본
      도구는 이를 보증하지 않습니다.
    </div>
  );
}
